export default "__VITE_ASSET__C4QCUy8q__"